<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <div class="tabs-max-width">
        <v-tabs v-model="tab" grow mobile-breakpoint="768px" class="tab-btn-style">
          <v-tab class="c-tab"> Upload Work </v-tab>
          <v-tab class="c-tab" v-if="permitObj.previousWork"> Previous Work</v-tab>
        </v-tabs>
      </div>
      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>

    <div class="nmt-1">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <upload-work></upload-work>
        </v-tab-item>
        <v-tab-item v-if="permitObj.previousWork">
          <previous-work :getdata="getdata"></previous-work>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import uploadWork from "../../../components/uploadWork/uploadWork.vue";
import PreviousWork from "../../../components/uploadWork/previousWork.vue";
import { getPermitObjects } from '../../../utils/allowedPermissions';

export default {
  name: "Upload",
  components: {
    uploadWork,
    BreadCrumbs,
    PreviousWork,
  },
  data() {
    return {
      getdata: "ertyu",
      tab: null,
      permitObj : {},
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: "Upload Work",
          disabled: true,
          to: {
            name: "Upload",
          },
        },
      ],
    };
  },
  methods: {
    getPermittedArray() {
      let links = this.$store?.getters?.permissions;
      let pathName = "Upload";
      this.permitObj = getPermitObjects(links, pathName);
    }
  },
  mounted() {
    // console.log(this.$vuetify.theme.secondry)
    this.getPermittedArray();
  },
};
</script>

<style  lang="scss">
.nmt-1 {
  margin-top: -12px;
}
.c-tab {
  background: #f2f0f0;
  transition: background-color 0.2s;
  &.v-tab--active {
    background: white;
  }
}
</style>
<style scoped>
.tabs-max-width {
  width: 450px;
}
@media only screen and (max-width: 768px) {
  .tabs-max-width {
    width: 100% !important;
    min-width: 100% !important;
  }
  .d-flex.justify-space-between {
    display: block !important;
  }
}
</style>